/** App version shown on the Settings screen. Bump the patch on every publish
 *  (push to main or release); the user calls major bumps. */
export const APP_VERSION = "0.1.97";
